export default __webpack_public_path__ + "static/1st-step-36867d1a25042562678fb52254b80585.png";